const homeStore = {
  state: {
    isMobile: false,
    isSmallDisplay: false,
    viewWidth: undefined,
    viewHeight: undefined,
    isZh: false,
    currentProperty: undefined,
    calculatePrice: undefined
  },
  mutations: {
    setMobile(state, value){
      state.isMobile = value
    },
    setSmallDisplay(state, value){
      state.isSmallDisplay = value
    },
    setViewWidth(state, value){
      state.viewWidth = value
    },
    setViewHeight(state, value){
      state.viewHeight = value
    },
    setZh(state, value) {
      state.isZh = value
    },
    setCurrentProperty(state, propertyId){
      state.currentProperty = propertyId
    },
    setCalculatePrice(state, price){
      state.calculatePrice = price
    }
  }
}

export default homeStore
